import React from 'react';

type VisibilityMemoryQAProps = {
  width?: string;
  height?: string;
  color?: string;
  style?: React.CSSProperties;
};

function VisibilityMemoryQA({
  width = '14',
  height = '14',
  color = '#6267AC',
}: VisibilityMemoryQAProps) {
  return (
    <svg
      width={width}
      height={height}
      color={color}
      viewBox='0 0 16 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.61342 6.47537C1.52262 6.33161 1.47723 6.25973 1.45182 6.14886C1.43273 6.06559 1.43273 5.93425 1.45182 5.85097C1.47723 5.74011 1.52262 5.66823 1.61341 5.52447C2.36369 4.33648 4.59693 1.33325 8.00027 1.33325C11.4036 1.33325 13.6369 4.33648 14.3871 5.52447C14.4779 5.66823 14.5233 5.74011 14.5487 5.85097C14.5678 5.93425 14.5678 6.06559 14.5487 6.14886C14.5233 6.25973 14.4779 6.33161 14.3871 6.47537C13.6369 7.66336 11.4036 10.6666 8.00027 10.6666C4.59693 10.6666 2.36369 7.66336 1.61342 6.47537Z'
        stroke='#404040'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M8.00027 7.99992C9.10484 7.99992 10.0003 7.10449 10.0003 5.99992C10.0003 4.89535 9.10484 3.99992 8.00027 3.99992C6.8957 3.99992 6.00027 4.89535 6.00027 5.99992C6.00027 7.10449 6.8957 7.99992 8.00027 7.99992Z'
        stroke='#404040'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default VisibilityMemoryQA;
